import { useContext, useRef } from "react";
import { useDay } from "@datepicker-react/hooks";
import { usePathname } from "next/navigation";
import { DayStatus, NewDayObject } from "commonModule/calendar";
import DatepickerContext from "./datepicker-context";
interface DayProps {
  annotatedCalendarDay: NewDayObject | null;
  date: Date;
  isDisabledDate?: boolean;
}
function Day({
  date,
  annotatedCalendarDay,
  isDisabledDate = false
}: DayProps) {
  const pathname = usePathname();
  const isFavoritesPage = pathname?.startsWith("/favorites");
  const dayRef = useRef(null);
  const {
    focusedDate,
    isDateHovered,
    isDateFocused,
    isDateSelected,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateHover,
    onDateFocus,
    onDateSelect,
    startDate,
    endDate
  } = useContext(DatepickerContext);
  const {
    isSelected,
    isSelectedStartOrEnd,
    isWithinHoverRange,
    onClick,
    onKeyDown,
    onMouseEnter,
    tabIndex
  } = useDay({
    date,
    // @ts-expect-error-next-line
    dayRef,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateSelect,
    onDateFocus,
    onDateHover
  });
  const isEnabled = annotatedCalendarDay ? annotatedCalendarDay.status === DayStatus.ENABLED : true;
  const isDisabled = annotatedCalendarDay ? annotatedCalendarDay.status === DayStatus.DISABLED : false;
  const isStriked = annotatedCalendarDay ? annotatedCalendarDay.status === DayStatus.STRIKED : false;
  // Convert dates to the same format for comparison
  const isSameDay = (d1: Date, d2: Date) => d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();

  // Logic to determine if the date is the start or end date in the selected range
  const isStartDate = startDate && isSameDay(date, startDate);
  const isEndDate = endDate && isSameDay(date, endDate);
  const btnClass = `${isFavoritesPage ? "fav-calendar_btn calendar_btn" : "calendar_btn"} ${isDisabledDate || isStriked ? "calendar_btn_not_available" : ""} ${isStartDate ? "first_or_last_selected_date start_date" : ""} ${isEndDate ? "first_or_last_selected_date end_date" : ""} ${isWithinHoverRange || isSelected ? "within_range" : ""}`;
  return <button ref={dayRef} className={btnClass} onClick={isEnabled ? onClick : () => null} onKeyDown={onKeyDown} onMouseEnter={onMouseEnter} tabIndex={isEnabled ? tabIndex : -1} type='button' disabled={isDisabledDate || isStriked || !isSelected && isDisabled} data-tooltip={Array.isArray(annotatedCalendarDay?.msg) ? annotatedCalendarDay?.msg?.[annotatedCalendarDay?.msg?.length - 1] : undefined} data-sentry-component="Day" data-sentry-source-file="day.tsx">
      <p className={`${isSelectedStartOrEnd ? "date_show" : ""} text-center text-sm font-semibold leading-[49px] text-[#26262B]`}>
        {date.getDate()}
      </p>
    </button>;
}
export default Day;